import { EStudentPaymentStatus } from '@constants';

import { RequestService } from '../request/request.service';

import { IUserInfo, IUpdatePaymentStatus, IUpdatePaymentStatusBulk } from './user-info.contract';

export class UserInfoService extends RequestService {
  public constructor(apiUrl: string) {
    super(apiUrl);
  }

  public getUserInfoById = async (userId: string) => {
    return this.fetcher<IUserInfo>(`/user-info/${userId}`);
  };

  public updateUserInfo = async (userId: string, userInfo: Partial<IUserInfo>) => {
    return this.putter<IUserInfo, Partial<IUserInfo>>(`/user-info/${userId}`, userInfo);
  };

  public updatePaymentStatus = async (userId: string, paymentStatus: EStudentPaymentStatus) => {
    return this.putter<IUserInfo, IUpdatePaymentStatus>(`/user-info/${userId}/payment-status`, {
      paymentStatus
    });
  };

  public changePaymentStatusInBulk = async (
    studentIds: string[],
    status: EStudentPaymentStatus
  ) => {
    return this.putter<void, IUpdatePaymentStatusBulk>(`/user-info/students/bulk-update-status`, {
      studentIds,
      status
    });
  };
}
